import { find, propEq, path } from 'ramda';

import { OTHER } from '../constants/fieldTypes';

export const getOtherId = (options, namePath = 'name', valuePath = 'id') => (
    path([valuePath], find(propEq(namePath, OTHER), options))
);
